<template>
    <div v-if="messages.messages.length" class="space-y-2">
        <div
            v-for="(message, i) in messages.messages"
            :key="i"
            class="rounded px-3 py-2 text-center"
            :class="{
                'bg-success text-white': message.type === 'success',
                'bg-danger text-white': message.type === 'used',
                'bg-warning text-black': message.type === 'not-found'
            }"
        >
            <Check v-if="message.type === 'success' && message.sent" class="inline w-4 h-4 mr-1" />
            <span v-html="message.message" />
            <div v-if="message.extra" class="text-sm opacity-90 mt-1" v-html="message.extra" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useMessagesStore } from '@/stores/messages'
    import { Check } from 'lucide-vue-next'
    const messages = useMessagesStore()
</script>
